import store from "./store";
import {CdnLibrary} from "../const/common";
import {HttpRequest} from "./HttpRequest";

class MaType {
}

MaType.BACK_GROUND_PIC = 2;
MaType.ROLE_PIC = 1;
MaType.AUDIO = 3;
MaType.OTHER_PIC = 4;
MaType.EMO_PIC = 5;
MaType.MAN_ID = store.state.manID;
MaType.WOMAN_ID = store.state.womanID;

class MaLib extends HttpRequest{
  constructor(vue) {
    super(vue);
    this.comentData = {
      resData: [],//存放的是素材列表数据
      firstData: [],//一级标题数据
      secondData: [],//二级标题
      thirdData: []//三级标题
    }
    this.page = null;
    this.type = null;
    this.sucCall = null;
    this.errCall = null;
    this.caller = null;
  }

  initComentData() {
    this.comentData = {
      resData: [],//存放的是素材列表数据
      firstData: [],//一级标题数据
      secondData: [],//二级标题
      thirdData: []//三级标题
    }
  }

  initTypeData(type, page, suc, err, caller, isLoading) {
    this.page = page;
    this.type = type;
    this.sucCall = suc;
    this.errCall = err;
    this.caller = caller;
    this.vue.isLoading = isLoading;
    //获取大分类
    this.getTypeById(0, type, (ld) => {
      let id = this.getZeroTypeId(ld, false);
      if (!id) {
        this.errorComplete();
        return;
      }
      this.getFirstData(ld, page);
    }, this.errorComplete);
  }

  getFirstData(ld, page) {
    if (this.type === 1) {
      this.vue.firstId = store.state.createRole.gender === 'man'? MaType.MAN_ID: MaType.WOMAN_ID;
    } else {
      if (!this.vue.firstId) {
        this.vue.firstId = this.getZeroTypeId(ld, false);
      }
    }

    if (!this.vue.firstId) {
      this.comentData.firstData = [];
      this.comentData.secondData = [];
      this.comentData.thirdData = [];
      this.comentData.resData = [];
      this.errorComplete();
      return;
    }
    this.getTypeById(this.vue.firstId, this.type, (ld1) => {
      this.comentData.firstData = ld1.data.data;
      this.getSecondData(ld1, page);
    }, this.errorComplete);
  }

  getSecondData(ld, page) {
    if (!this.vue.secondId) {
      this.vue.secondId = this.getZeroTypeId(ld, true);
    }
    if (!this.vue.secondId) {
      this.comentData.secondData = [];
      this.comentData.thirdData = [];
      this.comentData.resData = [];
      this.errorComplete();
      return;
    }
    this.getTypeById(this.vue.secondId, this.type, (ld1) => {
      this.comentData.secondData = ld1.data.data;
      this.getThirdData(ld1, page);
    }, this.errorComplete);
  }

  getThirdData(ld, page) {
    if (!this.vue.thirdId) {
      this.vue.thirdId = this.getZeroTypeId(ld, false);
    }
    if (!this.vue.thirdId) {
      this.comentData.thirdData = [];
      this.comentData.resData = [];
      this.errorComplete();
      return;
    }
    this.getTypeById(this.vue.thirdId, this.type, (ld1) => {
      this.comentData.thirdData = ld1.data.data;
      this.getListData(ld1, page);
    }, this.errorComplete);
  }

  getListData(ld, page) {
    if (!this.vue.listId) {
      this.vue.listId = this.getZeroTypeId(ld, false);
    }
    if (!this.vue.listId) {
      this.comentData.listId = [];
      this.errorComplete();
      return;
    }
    this.getGoodsListById(this.vue.listId, (ld1) => {
      this.comentData.resData = ld1.data[0].data;
      this.sucCall && this.sucCall.call(this.caller, ld1);
      this.vue.isLoading = false;
    }, this.errorComplete, page);
  }

  //
  getZeroTypeId(ld1, def) {
    if (ld1) {
      if (ld1.data) {
        if (ld1.data.data && ld1.data.data[0]) {
          let res = ld1.data.data[0].id;

          if (def && (this.type === 2 || this.type === 1 || this.type === 3)) {
            let defStyle = Middle.ProjectData.header.style, _name = '现代';

            if (defStyle) {
              _name = '古代';
            }
            ld1.data.data.forEach(function (item) {
              if (item.name === _name) {
                res = item.id;
              }
            });
          }
          return res
        }
      }
    }
    return null;
  }

  errorComplete() {
    this.errCall && this.errCall.call(this.caller, []);
    this.vue.isLoading = false;
  }

  //大分类 //一级标题   //二级标题  //三级标题
  getTypeById(cid, type, suc, err) {
    let url = CdnLibrary.request.GET_CATEGORY_LISTS + '?cid=' + cid + '&type=' + type;
    this.httpRequest(url, suc, err, this);
  }

  setIdByTitleType(id, type) {
    switch (type) {
      case 1:
        this.vue.firstId = id;
        this.vue.secondId = 0;
        this.vue.thirdId = 0;
        this.vue.listId = 0;
        break;
      case 2:
        this.vue.secondId = id;
        this.vue.thirdId = 0;
        this.vue.listId = 0;
        break;
      case 3:
        this.vue.thirdId = id;
        this.vue.listId = 0;
        break;
      case 4:
        this.vue.listId = id;
        break;
      default:
        this.vue.firstId = 0;
        this.vue.secondId = 0;
        this.vue.thirdId = 0;
        this.vue.listId = 0;
        break;
    }
    this.initComentData();
  }

  //获取内容列表
  getGoodsListById(cid, suc, err, page) {
    let url = CdnLibrary.request.GET_GOODS_LISTS + '?cid=' + cid + '&page=' + page;
    this.httpRequest(url, suc, err, this);
  }

  //获取内容详细
  getGoodDetail(id, suc, err, caller) {
    let url = CdnLibrary.request.GET_GOODS_DETAILS + '?gid=' + id;
    this.httpRequest(url, suc, err, caller);
  }
}

export {MaType, MaLib}



// WEBPACK FOOTER //
// ./src/store/MaLib.js